import React, { useMemo } from 'react'
import {
  ContentSection,
  Paragraph,
} from '@vwfs-bronson/bronson-react'
import {
  getOriginSystem,
  isAUDI,
} from '../../../services/common/utils'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getStorefrontData } from '../../../services/redux/features/storefront.redux'

const SummaryVehicleSectionSuffix = () => {
  const { t } = useTranslation()
  const storefrontData = useSelector(getStorefrontData)
  const originSystem = useMemo(() => getOriginSystem(storefrontData), [storefrontData])
  const data = useMemo(() => ({
    companyName: storefrontData?.dealerData?.companyName,
    dealerAddress1: storefrontData?.dealerData?.address?.street && storefrontData?.dealerData?.address?.houseNumber
      ? `${storefrontData?.dealerData?.address?.street} ${storefrontData?.dealerData?.address?.houseNumber}`
      : '',
    dealerAddress2: storefrontData?.dealerData?.address?.zipCode && storefrontData?.dealerData?.address?.city
      ? `${storefrontData?.dealerData?.address?.zipCode} ${storefrontData?.dealerData?.address?.city}`
      : ''
  }), [storefrontData])

  return (
    <>
      {isAUDI(storefrontData) && (
        <ContentSection.ComponentWrapper className="u-mt">
          {(t(`summaryVehicle:${originSystem}:suffix:1`, { returnObjects: true, ...data}) as string[])?.map(text => (
            <Paragraph>
              {t(text, { companyName: 'PRUEBA'})}
          </Paragraph>
          ))}
          <Paragraph className="u-mb-none">
            {t(
              `summaryVehicle:${originSystem}:suffix:dealer`
            )}
            <br />
            {storefrontData?.dealerData?.companyName}
            <br />
            {`${storefrontData?.dealerData?.address?.street} ${storefrontData?.dealerData?.address?.houseNumber}`}
            <br />
            {`${storefrontData?.dealerData?.address?.zipCode} ${storefrontData?.dealerData?.address?.city}`}
          </Paragraph>
        </ContentSection.ComponentWrapper>
      )}
    </>
  )
}

export default SummaryVehicleSectionSuffix
